import React, {useEffect, useState} from "react";
import {Button, Modal, notification, Table, Tag} from "antd";
import {ClockCircleOutlined} from "@ant-design/icons";
import Spinner from "../../spinner";
import {billingServices} from "../../../services/billing.services";
import i18n from "../../../i18n";

export default function ModalInvoicesHistory({legalEntityId, isShow, setIsShow}) {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);

    // Безопасное извлечение payload из ответа API: { status, data } -> data
    function getPayload(response) {
        if (response && response.data && response.data.data) {
            return response.data.data;
        }
        return [];
    }

    useEffect(() => {
        if (legalEntityId && isShow) {
            setLoading(true);
            billingServices.getPaidInvoices(legalEntityId)
                .then((response) => {
                    setInvoices(getPayload(response) || []);
                })
                .catch((err) => {
                    const description = typeof err === 'string'
                        ? err
                        : (err && err.message ? err.message : err);
                    notification.error({
                        message: i18n.t('components.notification.titles.subscription'),
                        description: description,
                    });
                })
                .finally(() => setLoading(false));
        }
    }, [legalEntityId, isShow]);

    function formatAmount(value) {
        if (value === null || value === undefined) {
            return '—';
        }
        return Number(value).toLocaleString('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) + ' ₽';
    }

    // Аналог nullish coalescing (??), который запрещён соглашениями проекта
    function or(value, fallback) {
        return value === null || value === undefined ? fallback : value;
    }

    const columns = [
        {
            title: 'Номер',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: 'Сумма',
            dataIndex: 'amount',
            key: 'amount',
            render: (value) => formatAmount(value),
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            key: 'status',
            render: () => <Tag color="green">Оплачен</Tag>,
        },
        {
            title: 'Дата создания',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (value) => or(value, '—'),
        },
        {
            title: 'Дата оплаты',
            dataIndex: 'paidAt',
            key: 'paidAt',
            render: (value) => or(value, '—'),
        },
        {
            title: '',
            key: 'download',
            render: (_, record) => (
                <Button
                    type="link"
                    size="small"
                    href={record.fileUrl}
                    target="_blank"
                    disabled={!record.fileUrl}
                >
                    {i18n.t('consignorPage.subscription.invoicesCard.download')}
                </Button>
            ),
        },
    ];

    return (
        <Modal
            title={<span><ClockCircleOutlined/> История счетов</span>}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={() => setIsShow(false)}
            footer={null}
            width={720}
        >
            <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
                <Table
                    columns={columns}
                    dataSource={invoices}
                    bordered={true}
                    pagination={false}
                    locale={{emptyText: 'Нет оплаченных счетов'}}
                    className="employees-table"
                    rowKey="id"
                />
            </Spinner>
        </Modal>
    );
}
